import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
})
export class WarningModalComponent implements OnInit {
  title = '';
  errorMessage = '';
  showCancelButton = true;
  constructor(
    private dialogRef: MatDialogRef<WarningModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data?.title;
    this.errorMessage = data?.message;
    if (data?.showCancelButton == false) this.showCancelButton = false;
  }
  public closeMe(status: any) {
    this.dialogRef.close({ data: status });
  }

  ngOnInit(): void {}
}
